/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useContext } from "react";
import axios from "axios";
import { NavLink, withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

import context from "../../../../../../context/auth-context";
import errorImage from "../../../../../../assets/images/image-error.png";
import errorHandler from "../../../../../../hoc/ErrorHandler";
import preloader from "../../../../../../assets/images/preloader.gif";

const UserProfile = (props) => {
  const authContext = useContext(context);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!authContext.authenticated) props.history.replace({ pathname: "/" });
    const getUserAvatar = async () => {
      const response = await axios.get(
        `/users/${authContext.userId}/account/avatar`,
        {
          headers: {
            "Company-Code": authContext.companyCode,
          },
          responseType: "blob",
        }
      );

      if (response) {
        // console.log("Test", response.data instanceof Blob);
        response.data instanceof Blob
          ? props.onSetAvatarURI(response.data)
          : console.log("NO DATA");
      } else {
        props.onSetAvatarURIError();
      }
    };
    const getUserGroups = async () => {
      const groups = await axios.get(
        `/users/${authContext.userId}/account/groups`,
        {
          headers: {
            "Company-Code": authContext.companyCode,
            "Company-Id": authContext.companyId,
          },
        }
      );

      if (groups) {
        return props.onInstantiateGroups(groups.data);
      } else {
        return props.onInstantiateGroupsError();
      }
    };

    getUserAvatar();
    getUserGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authContext.authenticated, authContext.companyId]);

  const userSignOutHandler = () => {
    axios
      .post(`/auth/logout`, { userName: authContext.loginName })
      .then((res) => {
        dispatch({ type: "REMOVE_LOADING" });
        if (res) {
          props.onClearGeoInfo();
          props.onClearTimeZones();
          props.onClearCompanies();
          props.onSignOut();
          props.history.replace({ pathname: "/" });
        }
      })
      .catch((err) => {
        alert("Cannot Log Out, Please Try Again");
      });
  };

  const fl = !props.avatarURI.error
    ? props.avatarURI.URI ?? preloader
    : errorImage;
  // console.log("Test",fl);

  return (
    <li className="nav-item dropdown" id="profile-menu">
      <a
        className="nav-link navbar-avatar"
        data-toggle="dropdown"
        aria-expanded="false"
        data-animation="scale-up"
        role="button"
      >
        <span
          className={
            props.avatarURI.error
              ? "avatar avatar-offline"
              : "avatar avatar-online"
          }
        >
          <img
            src={
              !props.avatarURI.error
                ? props.avatarURI.URI ?? preloader
                : errorImage
            }
            alt={authContext.userName}
          />
          <i></i>
        </span>
      </a>
      <div className="dropdown-menu" role="menu">
        <NavLink to="/auth/profile" className="dropdown-item" role="menuitem">
          <i className="icon ti-user" aria-hidden="true"></i>&nbsp;Profile
        </NavLink>
        <div className="dropdown-divider"></div>
        <button
          className="btn btn-link dropdown-item"
          role="menuitem"
          data-toggle="modal"
          data-target="#screenLockModal"
        >
          <i className="icon ti-lock" aria-hidden="true"></i>&nbsp;Lock screen
        </button>
        <button
          className="btn btn-link dropdown-item"
          role="menuitem"
          onClick={userSignOutHandler}
        >
          <i className="icon ti-power-off" aria-hidden="true"></i>&nbsp;Logout
        </button>
      </div>
    </li>
  );
};

const mapStateToProps = (state) => {
  return {
    avatarURI: state.auth.avatarURI,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetAvatarURI: (URI) => dispatch({ type: "SET_AVATAR_URI", payload: URI }),
    onSetAvatarURIError: () => dispatch({ type: "SET_AVATAR_URI" }),
    onSignOut: () => dispatch({ type: "SIGN_OUT" }),
    onClearGeoInfo: () => dispatch({ type: "CLEAR_GEO_INFO" }),
    onClearTimeZones: () => dispatch({ type: "CLEAR_TIME_ZONES" }),
    onClearCompanies: () => dispatch({ type: "CLEAR_COMPANIES" }),
    onInstantiateGroups: (groups) =>
      dispatch({ type: "INSTANTIATE_USER_GROUPS", payload: groups }),
    onInstantiateGroupsError: () =>
      dispatch({ type: "INSTANTIATE_USER_GROUPS_ERROR" }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(errorHandler(UserProfile, axios)));
